import React, { useState, useEffect, useRef } from 'react';
import headerImage from 'assets/img/error/error-429-header-image.svg';
import headerImageShadow from 'assets/img/error/error-429-header-image-shadow.svg';
import { useSelector, useDispatch } from 'react-redux';
import { UiButton } from 'ui-components';
import Loading from 'components/loading/Loading';
import {
  logoutUser,
  subtractSecondFromErrorTTL,
  fetchSearchLimitStatus,
} from 'store';
import { useDispatchContext, initialState } from 'context';
import { useNavigate } from 'react-router-dom';
import { magicNumbers, getSecondaryLogoURL } from 'utils';
import { useTranslation } from 'react-i18next';
import { toast } from 'lib';
import { Error429Style } from './Error429.styles';

const Error429 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dispatchContext = useDispatchContext();
  const error429 = useSelector((state) => state.errorReducer.error_429);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const timer = useRef(null);

  const initTimer = async () => {
    if (error429?.type === 'quarter') {
      timer.current = setInterval(
        () =>
          dispatch(
            subtractSecondFromErrorTTL({ error: 'error_429', second: 1 })
          ),
        magicNumbers?.ONE_SECOND
      );
    }
  };

  const handleVisibilityChange = async () => {
    await dispatch(fetchSearchLimitStatus()).unwrap();
  };

  useEffect(() => {
    if (error429?.remainingTime <= 0) {
      return;
    }
    initTimer();
    handleVisibilityChange();
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      clearInterval(timer.current);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const minutes = Math.floor(error429?.remainingTime / 60);
  const seconds = error429?.remainingTime % 60;

  const logout = async () => {
    setLogoutLoading(true);
    try {
      await dispatch(logoutUser()).unwrap();
      dispatchContext({ type: 'logout', ...initialState });
      navigate('/login');
      setLogoutLoading(false);
    } catch (error) {
      setLogoutLoading(false);
      toast({
        title: t('users:error.logout.description'),
        description: t('users:error.logout.description'),
        type: 'error',
      });
    }
  };
  let errorText = '';
  if (error429?.loading) {
    errorText = <Loading spinning />;
  } else if (error429?.type === 'daily') {
    errorText = (
      <>
        <p className='content-description'>
          {t('users:yourAccountHasBeenLimited')}
        </p>
        <UiButton
          onClick={logout}
          disabled={logoutLoading}
          loading={logoutLoading}
          className='content-logout'
        >
          {t('users:logout')}
        </UiButton>
      </>
    );
  } else if (error429?.type === 'quarter') {
    errorText = (
      <>
        <p className='content-description'>
          {t('users:yourAccountIsTemporarilyRestricted')}
        </p>
        <p className='content-description'>
          {t('users:youCanAccessYourAccountAfterAWhile', {
            minutes: minutes,
            seconds: seconds,
            extraZero: seconds < 10 ? '0' : '',
          })}
        </p>
      </>
    );
  }

  return (
    <Error429Style>
      <div className='error-429'>
        <div className='error-429-header'>
          <div className='header-image'>
            <img className='img' src={headerImage} />
            <img className='shadow' src={headerImageShadow} />
          </div>
        </div>
        <div className='error-429-content'>
          <h2 className='content-title'>{t('users:errorStatus429')}</h2>
          {errorText}
        </div>
        <div className='error-429-logo'>
          <img
            className={`logo-image ${
              error429?.type === 'daily' ? 'mt-50' : 'mt-70'
            }`}
            src={getSecondaryLogoURL()}
          />
        </div>
      </div>
    </Error429Style>
  );
};

export default Error429;
